import { Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class ValidatableInputMixin extends Vue {
  @Prop({
    default: false
  }) hasErrors: boolean;

  get errorMessages() {
    return this.hasErrors 
      ? 'error' 
      : null;
  }
}